import { useState } from "react";
import { MessageSquarePlus, X } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const MAX = 300;

export const ExplanationField = ({ value, onChange, testidPrefix = "explanation" }) => {
  const [open, setOpen] = useState(!!value);
  if (!open) return (
    <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 text-xs font-medium text-blue-700 hover:text-blue-900 transition-colors" data-testid={`${testidPrefix}-add`}>
      <MessageSquarePlus className="h-4 w-4" /> Add explanation (optional)
    </button>
  );
  return (
    <div data-testid={`${testidPrefix}-box`}>
      <div className="flex items-center justify-between">
        <Label className="text-xs">Explanation (optional)</Label>
        <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="text-slate-400 hover:text-red-600" aria-label="Remove explanation" data-testid={`${testidPrefix}-remove`}><X className="h-4 w-4" /></button>
      </div>
      <Textarea value={value} maxLength={MAX} rows={2} onChange={(e) => onChange(e.target.value)} placeholder="e.g. Paid ₹1000 cash + ₹500 UPI; balance next week" className="mt-1 text-sm" data-testid={`${testidPrefix}-input`} />
      <p className="text-[11px] text-slate-400 text-right">{value.length}/{MAX}</p>
    </div>
  );
};
